module.exports = __webpack_public_path__ + "img/mn.9ebe47eb.svg";